import { DialogModule, Dialog } from '@angular/cdk/dialog';
import { Component, effect, inject, OnInit, Signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouteReuseStrategy } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { HeaderComponent } from '../../components/header/header.component';
import { StepperComponent } from '../../components/stepper/stepper.component';
import { TextAreaComponent } from '../../components/text-area/text-area.component';
import TYPES from '../../constants/types';
import { Log } from '../../models/log';
import { DatabaseService, DATABASE_SERVICE } from '../../services/database.service';
import { LogService } from '../../services/log.service';
import { CustomRouteReuseStrategy } from '../../util/custom-route-reuse-strategy';

@Component({
  selector: 'app-other-thought',
  imports: [
    HeaderComponent,
    StepperComponent,
    ButtonComponent,
    TranslatePipe,
    MatSnackBarModule,
    DialogModule,
    TextAreaComponent
  ],
  templateUrl: './other-thought.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './other-thought.component.scss'
})
export class OtherThoughtComponent {

  BUTTON_TYPES:any;
  step: Signal<StepperComponent | undefined> = viewChild<StepperComponent>('stepper');

  otherThoughtControl: UntypedFormControl;

  snackBar:MatSnackBar = inject(MatSnackBar);
  dialog: Dialog = inject(Dialog);
  translate: TranslateService = inject(TranslateService);

  databaseService:DatabaseService<Log> = inject(DATABASE_SERVICE);

  constructor(
    private router:Router,
    private logService: LogService<Log>,
    private reuseStrategy: RouteReuseStrategy
  ){
    effect( ()=> {
      this.step()?.steps()[6].nativeElement.classList.add('active');
    });

    this.otherThoughtControl = new UntypedFormControl(this.logService.log().other_thought || '');

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  async next(){
    this.logService.log.update( 
      (current) => {
        return {
          ...current,
          other_thought: this.otherThoughtControl.value,
        }
      }
    );

    let logCreated: Log;
    if(!this.logService.log().id){
      const {id, logs_shared, created_at, updated_at, ...nonStoredLog} = this.logService.log();
      logCreated = await this.databaseService.create(TYPES.DATABASE.TABLES.LOGS, nonStoredLog);
    }else{
      const {logs_shared, ...storedLog} = this.logService.log();
      logCreated = await this.databaseService.update(TYPES.DATABASE.TABLES.LOGS, this.logService.log().id || '', storedLog);
    }
    this.logService.log.set(logCreated);
    this.logService.canAccessMindLogRegister.set(false);

    //Delete the previous cache from historical screen
    const customReuseStrategy = this.reuseStrategy as CustomRouteReuseStrategy;
    customReuseStrategy.clearRoute('home/(home:historical)');

    this.router.navigate(['/share-log'], { replaceUrl: true });
  }

  back(){
    history.back();
  }

  close(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'log-close-dialog.alert_title',
        message: 'log-close-dialog.alert_message'
      },
    });

    dialogRef.closed.subscribe((result:any)  => {
      if(result?.action === 'continue'){
        this.logService.canAccessMindLogRegister.set(false);
        this.router.navigate(['/home'], { replaceUrl: true });  
      }
    });   
  }

}
